import React from 'react';
import '../styles/components/_Loading.scss';

const Loading = ({ visible = true }) => {
    if (!visible) return null;

    return (
        <div className="app-loading" role="status" aria-live="polite">
            <div className="loading-inner">
                <div className="spinner" aria-hidden="true"></div>
                <div className="loading-text">Yükleniyor...</div>
            </div>
        </div>
    );
};

export default Loading;

